import {
  AuthenticationManager,
  ResourceID,
} from "../../../../common/AuthenticationManager";
import {
  PaymentStatus,
  TransactionStatus,
} from "../../../../constants/TransactionConstants";
import ButtonActionDetailGroup from "../../../common/ButtonActionDetailGroup";
import React, { useState } from "react";
import { ConfirmDialog } from "../../../common/ConfirmDialog";
import { TransactionService } from "../../../../services/TransactionService";
import { toast } from "react-toastify";
import { showLoading } from "../../../../common/Common";
import { EVoucherStatus } from "../../../../common/Constants";

function isAbleToReactivate(eVouchers) {
  return eVouchers.every((x) => x.status === EVoucherStatus.Used);
}

const getButtonTooltip = (eVouchers) => {
  const isValidToReactivate = isAbleToReactivate(eVouchers);
  if (isValidToReactivate) {
    return "Click to re-activate eVoucher";
  }
  const invalidCodes = eVouchers
    .filter((x) => x.status !== EVoucherStatus.Used)
    .map((x) => x.code)
    .join(", ");
  return `${invalidCodes} cannot be re-activated.`;
};

export default function EVoucherReactivation(props) {
  const { transaction, onSuccess, eVouchers } = props;
  const [confirmModal, setConfirmModal] = useState(false);

  const isValidateToReactivate =
    AuthenticationManager.isAuthorized(ResourceID.EVoucherReactivationButton) &&
    eVouchers &&
    eVouchers.length > 0 &&
    transaction.status === TransactionStatus.Failed &&
    transaction.paymentStatus === PaymentStatus.Captured;

  const onReactiveEVoucher = async () => {
    showLoading(true);
    const response = await new TransactionService().reactiveEVouchers(
      transaction.id
    );
    showLoading(false);
    setConfirmModal(false);
    if (response?.status === 200) {
      toast.success("The eVoucher has been successfully re-activated.");
      onSuccess();
    }
  };

  if (!isValidateToReactivate) {
    return null;
  }

  return (
    <>
      <ButtonActionDetailGroup.Item
        className="btn btn-primary"
        onClick={() => setConfirmModal(true)}
        title={getButtonTooltip(eVouchers)}
        disabled={!isAbleToReactivate(eVouchers)}
      >
        Re-Activate eVoucher
      </ButtonActionDetailGroup.Item>
      <ConfirmDialog
        title="eVoucher Reactivation"
        message="Are you sure you want to re-activate the eVoucher?"
        visible={confirmModal}
        onProceed={onReactiveEVoucher}
        onCancel={() => setConfirmModal(false)}
      />
    </>
  );
}
